import { Response } from '@angular/http';

export class ApiError extends Error {
  code: number;
  message: string;
  errors: any = [];
  api_raw_response: Response;
}



// WEBPACK FOOTER //
// ./src/app/common-theme/models/api-error.model.ts